
<template>
  <div class="help" @click="showHelp">

    <!-- dialogs -->    
    <na-help-content
      :show="showHelpPanel"
      v-on:did-select-ok="didCloseHelp"
      v-if="topic == 'na'"
    ></na-help-content>
    
    <fcc-help-content
      :show="showHelpPanel"
      v-on:did-select-ok="didCloseHelp"
      v-if="topic == 'fcc'"
    ></fcc-help-content>

    <v-container>
      <v-layout justify-center pt-3>
        <v-icon
          center
          color="blue darken-4"
          size="57"
        >
          help
        </v-icon>
      </v-layout>
      <v-layout justify-center>
          Need a little help getting started?
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'help-box',
  data () {
    return {
      showHelpPanel: false
    }
  },
  
  props: {
    topic: String
  },

  methods: {
    showHelp() {
      this.showHelpPanel = true
    },
    didCloseHelp() {
      this.showHelpPanel = false
    }
  },

  computed: {
  },

  components: {
    'help-content': () => import ('@/components/HelpContent'),
    'na-help-content': () => import ('@/components/NetworkAnalysisHelpContent'),
    'fcc-help-content': () => import ('@/components/FacilityCostCalculatorHelpContent')
  }
}

</script>


<style scoped>

.help {
  background-color: #EAF1FC;
  color: #4F78C4;
  font-size: 10pt;
  width: 162px;
  height: 100%;
  line-height: 1.85ch;
  position: absolute;
  text-align: center;
  top: 0;
  right: 0;
}

</style>